<template>
    <tr :class="`${isEditRequested || isViewDetailsRequested ? 'edit-row' : ''}`">
        <td><EmptyTextHandler :text="`${immunization.ProductName ? immunization.ProductName : 'Unknown'}`" /></td>
        <td><EmptyTextHandler :text="formatDate(immunization.DateOfVaccination)" /></td>
        <td><EmptyTextHandler :text="typeOfRecordEnumMap.getEnumName(immunization.TypeOfRecord)" /></td>
        <td><EmptyTextHandler :text="formatDate(immunization.DateOfDocumentation)" /></td>
        <td><EmptyTextHandler :text="immunization.AdministeredBy" /></td>
        <td v-if="!isDeleteRequested"><EmptyTextHandler :text="statusEnumMap.getEnumName(immunization.Status)" /></td>
        <td v-if="!isDeleteRequested">
            <EmptyTextHandler :text="getReasonNotPerformed(immunization.ReasonNotPerformedDisplayName)" />
        </td>
        <td v-if="!isDeleteRequested"><EmptyTextHandler :text="immunization.Comments" /></td>
        <td class="text-end" v-if="!isDeleteRequested">
            <div v-if="!isEditRequested && !isDeleteRequested && !isViewDetailsRequested">
                <button class="btn table-btn btn-outline-info" @click="openEditImmunization()">
                    <i class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-danger" @click="openDeleteRequest()">
                    <i class="fas fa-trash"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-info" @click="openViewDetails()">
                    View Details
                </button>
            </div>
            <i v-if="isEditRequested" class="fw-bold">Edit in Progress</i>
            <i v-if="isViewDetailsRequested" class="fw-bold">Viewing Details</i>
        </td>
        <td colspan="3" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="delete"
                cancel-text="Cancel"
                message="Do you want to delete this vaccine record?"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteImmunization"
                :cancel="closeDeleteRequest"
            ></TablePrompt>
        </td>
    </tr>
    <tr class="edit-row" v-if="isViewDetailsRequested">
        <td :colspan="columns" class="p-3">
            <DeclinedVaccineForm
                :immunization="cacheImmunization"
                :declined-value-set="declinedValueSet"
                :is-view-only="true"
                :type-of-record-enum="typeOfRecordEnum"
                v-if="statusEnumMap.checkEnumValue('Declined', immunization.Status)"
            />
            <VaccineRecordForm
                :immunization="cacheImmunization"
                :is-view-only="true"
                :application="application"
                :immunization-status-enum-map="statusEnumMap"
                :immunization-status-enum="immunizationStatusEnum"
                :type-of-record-enum="typeOfRecordEnum"
                :type-of-record-enum-map="typeOfRecordEnumMap"
                v-else
            />
            <div class="text-center">
                <button type="button" class="btn btn-outline-primary btn-md mt-2" @click="cancelViewDetails()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
    <tr class="edit-row" v-if="isEditRequested">
        <td :colspan="columns" class="p-3">
            <FormSection v-if="isEditInProgress">
                <template #content>
                    <div class="p-5 d-flex flex-column text-center text-primary">
                        <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                        <div class="big-text mt-1">
                            <b>Save Vaccine Record in Progress...</b>
                        </div>
                    </div>
                </template>
            </FormSection>
            <template v-else>
                <DeclinedVaccineForm
                    ref="declinedForm"
                    :is-edit="true"
                    :immunization="cacheImmunization"
                    :declined-value-set="declinedValueSet"
                    :type-of-record-enum="typeOfRecordEnum"
                    v-if="statusEnumMap.checkEnumValue('Declined', immunization.Status)"
                />
                <VaccineRecordForm
                    ref="vaccineForm"
                    :immunization="cacheImmunization"
                    :application="application"
                    :immunization-status-enum-map="statusEnumMap"
                    :immunization-status-enum="immunizationStatusEnum"
                    :is-edit="true"
                    :type-of-record-enum="typeOfRecordEnum"
                    :type-of-record-enum-map="typeOfRecordEnumMap"
                    v-else
                />
            </template>
            <div class="text-center" v-if="!isEditInProgress">
                <button type="button" class="btn btn-primary btn-md me-2" @click="editImmunization()">Save</button>
                <button type="button" class="btn btn-outline-primary btn-md" @click="cancelEditImmunization()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
</template>

<script src="./ImmunizationRow.ts"></script>
